module.exports = __webpack_public_path__ + "static/media/blue-element.2c492fe4.svg";